import React, { useState } from 'react';
import axios from 'axios';
import BASE_URL from '../config';

const PasswordReset = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  const handlePasswordReset = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/api/password-reset/`, {
        email,
      });
      setSuccess(true);
      setMessage(response.data.detail || 'If an account with that email exists, a reset link has been sent.');
    } catch (error) {
      setSuccess(false);
      if (error.response && error.response.data) {
        const data = error.response.data;
        const msg = data.detail || data.error || data.message || JSON.stringify(data);
        setMessage(msg);
      } else if (error.request) {
        setMessage('No response from server. Please try again.');
      } else {
        setMessage(error.message);
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2 className="auth-title">Forgot password?</h2>
        <p className="auth-subtitle">Enter your email and we'll send you a reset link</p>
        <div className="mb-3">
          <label className="auth-label">Email</label>
          <input
            type="email"
            className="form-control auth-input"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <button className="auth-btn" onClick={handlePasswordReset}>
          Send Reset Link
        </button>
        {message && (
          <p className="auth-message" style={{ color: success ? '#2e7d32' : '#c62828' }}>
            {message}
          </p>
        )}
        <div className="auth-links" style={{ marginTop: '16px' }}>
          <a href="/login">Back to Sign in</a>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
